export const moviesApiConfig = {
  api_url:
    "https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=a4299efd747250310a54f11d044965e8&page=1",
  poster_path: "https://image.tmdb.org/t/p/w1280",
  search_api:
    'https://api.themoviedb.org/3/search/movie?api_key=a4299efd747250310a54f11d044965e8&query="',
};
